import { useQuery } from '@abyss/web/hooks/useQuery';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import GetProviderIdentifierTypes from './GetProviderIdentifierTypesSearch.gql';

export const useProviderIdentifierTypesSearch = (options) => {
  return useQuery(GetProviderIdentifierTypes, {
    ...options,
    url: ApiUrl.graphQl(),
  });
};
